module.exports = __webpack_public_path__ + "img/Group 360@2x.6e09dbb8.png";